// First lesson in each subject is available; remaining lessons start locked.
export const INITIAL_CURRICULUM_ASSIGNMENTS = [
  {
    lesson_id: '69fb5832-d629-4f97-bb54-951232ade4d2',
    status: 'available'
  },
  {
    lesson_id: '96c83840-a79f-4ee0-aa4d-8a738694036a',
    status: 'locked'
  },
  {
    lesson_id: 'e4b9d250-893f-4f7e-ace1-266aab52867d',
    status: 'available'
  },
  {
    lesson_id: '3c206669-1b3c-4632-9c40-effc7ad3e9d6',
    status: 'locked'
  }
];

export function assignmentsForChild(childId) {
  return INITIAL_CURRICULUM_ASSIGNMENTS.map((row) => ({
    ...row,
    child_id: childId
  }));
}
